angular.module('lsnBase.deprecated.models')
  .factory('SimplePolicyModel', ['LsnSimplePolicyModelV1',
    function(LsnSimplePolicyModelV1) {
      return LsnSimplePolicyModelV1;
    }
  ]);